// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Col } from 'react-flexbox-grid';
import ProjectActions from '../actions/project.actions';
import GtmActions from '../actions/gtmapi.actions';
import WizardActions from '../actions/wizard.actions';
import Input from 'react-toolbox/lib/input';
import Dropdown from 'react-toolbox/lib/dropdown';
import MdAddCircleOutline from 'react-icons/lib/md/add-circle-outline';
import ProgressBar from 'react-toolbox/lib/progress_bar';
import qs from 'query-string';
import { routerActions } from 'react-router-redux';
import { bindActionCreators } from 'redux';
import { getTranslate } from 'react-localize-redux';
import Button from '../common/ButtonComp';
import Dialog from 'react-toolbox/lib/dialog/Dialog';
import ArrowRight from 'react-icons/lib/md/keyboard-arrow-right';
import './SelectAnalyticsPropertyComp.css';

class CreateUploadPropertyComp extends Component {
  state: {
    accountId: string,
    webPropertyId: string,
    internalWebPropertyId: string,
    webPropertyName: string,
    accountName: string,
    defaultProfileId: string,
    showNoEditPermissionsDialog: boolean,
    showDoNotChooseKWHDialog: any
  };
  constructor(props) {
    super(props);

    this.state = {
      accountId: props.project && props.project.accountId,
      webPropertyId: props.project && props.project.webPropertyId,
      internalWebPropertyId: props.project && props.project.internalWebPropertyId,
      webPropertyName: props.project && props.project.webPropertyName,
      accountName: props.project && props.project.accountName,
      defaultProfileId: props.project && props.project.profileId,
      showNoEditPermissionsDialog: false,
      showDoNotChooseKWHDialog: null
    };
  }

  selectAccount(account) {
    const {
      projectActions: { getWebProperties },
      project
    } = this.props;

    this.setState({
      accountId: account.id,
      accountName: account.name,
      webPropertyId: undefined,
      webPropertyName: undefined
    });

    getWebProperties({ id: project._id, accountId: account.id, accountName: account.name });
  }

  selectProperty(property) {
    if (!~property.permissions.effective.indexOf('EDIT')) {
      return this.setState({ showNoEditPermissionsDialog: true });
    }

    if (!!~property.name.indexOf(`Keyword Hero`)) {
      return this.setState({
        showDoNotChooseKWHDialog: {
          webPropertyId: property.id,
          internalWebPropertyId: property.internalWebPropertyId,
          webPropertyName: property.name,
          defaultProfileId: property.defaultProfileId
        }
      });
    }
    this.setState({
      webPropertyId: property.id,
      internalWebPropertyId: property.internalWebPropertyId,
      webPropertyName: property.name,
      defaultProfileId: property.defaultProfileId,
      showDoNotChooseKWHDialog: null
    });
  }

  handleChange = (name, value) => {
    this.setState({ [name]: value });
  };

  goNext = () => {
    const {
      projectActions: { saveGaSettings },
      routerActions,
      query: { idx = 0 },
      project,
      webProperties,
      wizard: { steps }
    } = this.props;
    const {
      accountId,
      webPropertyId,
      internalWebPropertyId,
      accountName,
      webPropertyName,
      defaultProfileId
    } = this.state;
    if (project.webPropertyId) {
      if (!!~steps.indexOf('select-plan')) return routerActions.push(`select-plan?idx=${idx}`);
      return routerActions.push(`create-datapoints?idx=${idx}`);
    }
    if (webProperties && webProperties.length) {
      const extendedWP = webProperties.filter((wp) => wp.id === webPropertyId)[0];
      if (
        extendedWP &&
        extendedWP.permissions &&
        !~extendedWP.permissions.effective.indexOf('EDIT')
      )
        return this.setState({ showNoEditPermissionsDialog: true });
    }
    saveGaSettings({
      idx,
      id: project._id,
      accountId,
      webPropertyId,
      internalWebPropertyId,
      defaultProfileId,
      accountName,
      webPropertyName,
      cb: () => {
        if (!!~steps.indexOf('select-plan')) return routerActions.push(`select-plan?idx=${idx}`);
        return routerActions.push(`create-datapoints?idx=${idx}`);
      }
    });
  };

  goBack = () => {
    const {
      query: { idx = 0 },
      routerActions
    } = this.props;
    const { accountId } = this.state;

    routerActions.push(`select-gtm-property?idx=${idx}`);
  };

  handleChangeDropdown = (tokenId) => {
    const {
      wizardActions: { selectAccount },
      project
    } = this.props;

    if (tokenId === 'add') {
      window.location.href = `/auth/with-google/add?projectId=${project._id}&projectIndex=${
        project.index
      }&isWebProperty=true`;
      return;
    }

    this.setState({ accountId: null, webPropertyId: null });

    selectAccount({
      tid: tokenId,
      projectId: project._id,
      accountId: project.accountId,
      isWebProperty: true
    });
  };

  componentDidMount() {
    const {
      projectActions: { getSummary, getWebProperties },
      gtmActions: { getUaVariables },
      project
    } = this.props;
    const {
      gtm: { accountId, containerId }
    } = project;
    getSummary({ id: project._id });
    getUaVariables({ id: project._id, accountId, containerId });
    if (project.webPropertyId) getWebProperties({ id: project._id, accountId: project.accountId });
  }

  render() {
    const {
      translate,
      project,
      accounts,
      webProperties,
      webPropertiesUpdating,
      accountsUpdating,
      accountsError,
      accountsEmptyError,
      propertiesError,
      isMatch,
      matched,
      uaCodesUpdating,
      summaryUpdating,
      summaryEmptyError,
      me,
      gaSaving
    } = this.props;

    const {
      accountId,
      webPropertyId,
      showNoEditPermissionsDialog,
      showDoNotChooseKWHDialog
    } = this.state;

    const noEditPermissionsDialog = (
      <Dialog
        active={showNoEditPermissionsDialog}
        onEscKeyDown={() => this.setState({ showNoEditPermissionsDialog: false })}
        onOverlayClick={() => this.setState({ showNoEditPermissionsDialog: false })}
        title={`You can't choose this web property`}
      >
        <div className="space-big-bottom">
          <p className="space-big-bottom">
            {`The app needs EDIT permissions to create custom dimensions. You have no EDIT permissions for this web property. Please ask admin of the web property for EDIT permissions.`}
          </p>
        </div>
        <div className="kwh-button-group">
          <Button big primary onClick={() => this.setState({ showNoEditPermissionsDialog: false })}>
            {translate('app.ok')}
          </Button>
        </div>
      </Dialog>
    );

    const doNotChooseKWHDialog = (
      <Dialog
        active={!!showDoNotChooseKWHDialog}
        onEscKeyDown={() => this.setState({ showDoNotChooseKWHDialog: null })}
        onOverlayClick={() => this.setState({ showDoNotChooseKWHDialog: null })}
        title={`You shouldn't choose Keyword Hero web property`}
      >
        <div className="space-big-bottom">
          <p className="space-big-bottom">
            {`The app will push datapoints only to property that is installed on the webpage. It will not work with Keyword Hero upload property.`}
          </p>
        </div>
        <div className="kwh-button-group">
          <Button
            big
            secondary
            onClick={() =>
              this.setState({ ...showDoNotChooseKWHDialog, showDoNotChooseKWHDialog: null })
            }
          >
            {translate('app.ok')}
          </Button>
          <Button big primary onClick={() => this.setState({ showDoNotChooseKWHDialog: null })}>
            {translate('app.back')}
          </Button>
        </div>
      </Dialog>
    );

    const accountsUpdatingProgress = accountsUpdating && (
      <ProgressBar type="linear" mode="indeterminate" />
    );
    const webPropertiesUpdatingProgress = webPropertiesUpdating && (
      <ProgressBar type="linear" mode="indeterminate" />
    );

    const accountsErrorMessage = (
      <p>
        {accountsEmptyError
          ? translate('wizard.select_analytics.accounts_not_exists', {
              email: project.accessEmail
            })
          : translate('wizard.select_analytics.account_access_error', {
              appAccEmail: project.accessEmail,
              projectIndex: project.index,
              projectId: project._id,
              isWebProperty: true
            })}
      </p>
    );

    const propertiesErrorMessage = (
      <p>
        {translate('wizard.select_analytics.account_permissions_error', {
          stateAccountId: this.state.accountId,
          appAccEmail: project.accessEmail
        })}
      </p>
    );

    let selectAccount = (
      <Row start="xs" className="space-big-bottom">
        <Col xs={4}>
          <h5>{translate('wizard.select_analytics.accounts')}</h5>
          <div className="select-list">
            {accountsUpdatingProgress}
            {!accountsUpdating &&
              !summaryEmptyError &&
              !accountsError &&
              accounts.map(AnalyticsAccountsSelectList.bind(this))}
          </div>
        </Col>
        <Col xs={7}>
          <h5>{translate('wizard.select_analytics.properties_apps')}</h5>
          <div className="select-list">
            {webPropertiesUpdatingProgress}
            {!summaryEmptyError && !accountsError && !propertiesError
              ? webProperties.map(AnalyticsWebPropertiesSelectList.bind(this))
              : accountsErrorMessage}
          </div>
        </Col>
      </Row>
    );

    const next = (
      <Button big primary onClick={this.goNext.bind(this)}>
        {translate('app.next')}
      </Button>
    );
    const choose = (
      <Button
        big
        primary
        disabled={!accountId || !webPropertyId}
        loading={gaSaving}
        onClick={this.goNext.bind(this)}
      >
        {translate('app.choose')}
      </Button>
    );
    const back = (
      <Button big secondary onClick={this.goBack.bind(this)}>
        {translate('app.back')}
      </Button>
    );

    if ((!project.ignoreGTM && !me.user.ignoreGTM && summaryUpdating) || uaCodesUpdating)
      selectAccount = (
        <div className="select-list">
          <ProgressBar type="linear" mode="indeterminate" />
        </div>
      );

    if (!project.ignoreGTM && !me.user.ignoreGTM && isMatch) {
      selectAccount = (
        <div className="space-big-bottom select-list">
          {matched.map(directWebPropertySelectList.bind(this))}
        </div>
      );
    }

    const accountList = me.user.googleAccounts.map(({ _id, email }) => ({
      value: _id,
      label: email
    }));

    accountList.push({
      value: 'add',
      label: translate('wizard.select_analytics.change_account')
    });

    const selectedAccount = me.user.googleAccounts.find(({ _id }) => {
      return project.webPropertyAccessId === _id;
    });

    return (
      <div className="wizard-upload_create">
        <h1>{translate('wizard.select_analytics.create_mirror')}</h1>
        <div className="space-big-bottom account-lead-text">
          {translate('wizard.select_analytics.create_mirror_user_for')}

          {project.accountId ? (
            <strong> {project.accessEmail}</strong>
          ) : (
            <Col className="accounts-dropdown-wrapper" xs={5}>
              <Dropdown
                auto
                onChange={this.handleChangeDropdown}
                className={'accounts-dropdown'}
                template={DropdownAccountItem(selectedAccount && selectedAccount._id)}
                source={accountList}
                value={selectedAccount && selectedAccount._id}
              />
            </Col>
          )}

          {translate('wizard.select_analytics.create_mirror_select_account')}
        </div>
        {/* TODO: think about names of account variables */}
        {selectedAccount && selectAccount}
        <div className="kwh-button-group">
          {back}
          {!!project.webPropertyId ? next : choose}
        </div>
        {noEditPermissionsDialog}
        {doNotChooseKWHDialog}
      </div>
    );
  }
}

function DropdownAccountItem(selectedValue) {
  return ({ value, label }) => {
    return (
      <div className={`dropdown-container ${value === 'add' && 'dropdown-change-element'}`}>
        <div className={`content-element ${value === selectedValue && 'active'}`}>{label}</div>
      </div>
    );
  };
}

function directWebPropertySelectList(property, i) {
  const {
    project,
    projectActions: { getWebProperties }
  } = this.props;
  const { accountId, internalWebPropertyId, accountName } = property;
  const isUploadAccountExists = !!project.webPropertyId;
  const isActiveAccount =
    this.state.webPropertyId === property.id || project.webPropertyId === property.id;
  const itemClassName = [
    'select-list_item',
    isUploadAccountExists && !isActiveAccount ? 'select-list_faded' : '',
    isActiveAccount ? 'active' : ''
  ].join(' ');
  return (
    <Row
      start="xs"
      className="select-list_rowitem"
      onClick={() => {
        this.setState({
          webPropertyId: property.id,
          accountId,
          internalWebPropertyId,
          accountName,
          webPropertyName: property.name
        });
        getWebProperties({ id: project._id, accountId, accountName });
      }}
    >
      <Col xs={4}>
        <div className={itemClassName} key={i}>
          {property.accountName} <ArrowRight className="select-list_arrow" />
        </div>
      </Col>
      <Col xs={7}>
        <div className={itemClassName} key={i}>
          <span>{property.name}</span> <small>{property.id}</small>
        </div>
      </Col>
    </Row>
  );
}

function AnalyticsAccountsSelectList(account, i) {
  const { project } = this.props;
  const isUploadAccountExists = !!project.webPropertyId;
  const isActiveAccount = this.state.accountId === account.id || project.accountId === account.id;
  const itemClassName = [
    'select-list_item',
    isUploadAccountExists && !isActiveAccount ? 'select-list_faded' : '',
    isActiveAccount ? 'active' : ''
  ].join(' ');
  const onClickAction =
    !isUploadAccountExists && !isActiveAccount && this.selectAccount.bind(this, account);
  return (
    <div className={itemClassName} onClick={onClickAction} key={i}>
      {account.name} <ArrowRight className="select-list_arrow" />
    </div>
  );
}

function AnalyticsWebPropertiesSelectList(property, i) {
  const { project } = this.props;
  const isUploadAccountExists = !!project.webPropertyId;
  const isActiveAccount =
    this.state.webPropertyId === property.id || project.webPropertyId === property.id;
  const itemClassName = [
    'select-list_item',
    isUploadAccountExists && !isActiveAccount ? 'select-list_faded' : '',
    isActiveAccount ? 'active' : ''
  ].join(' ');
  const onClickAction =
    !isUploadAccountExists && !isActiveAccount && this.selectProperty.bind(this, property);
  return (
    <div className={itemClassName} onClick={onClickAction} key={i}>
      <span>{property.name}</span> <small>{property.id}</small>
    </div>
  );
}

function getAccountById({ accounts, accountId }) {
  const matchedAccount = accounts.filter((account) => account.id === accountId);
  return matchedAccount && matchedAccount[0];
}

function mapStateToProps(state) {
  const {
    routing: {
      location: { search }
    },
    project: {
      accounts,
      webProperties,
      accountsUpdating,
      webPropertiesUpdating,
      webPropertiesCreating,
      accountsError,
      accountsEmptyError,
      webPropertiesError,
      gaSaving
    },
    gtm: {
      uaCodes,
      uaCodesUpdating,
      uaCodesError,
      summary,
      summaryUpdating,
      summaryEmptyError,
      summaryError,
      isMatch,
      matched
    }
  } = state;
  const query = search ? qs.parse(search) : { idx: 0 };
  const { projects = [] } = state.me.user;

  return {
    me: state.me,
    wizard: state.wizard,
    translate: getTranslate(state.locale),
    project: projects[query.idx],
    query,
    accounts,
    webProperties,
    webPropertiesError,
    accountsError,
    accountsEmptyError,
    accountsUpdating,
    webPropertiesUpdating,
    uaCodes,
    uaCodesUpdating,
    uaCodesError,
    summary,
    summaryUpdating,
    summaryError,
    summaryEmptyError,
    isMatch,
    matched,
    gaSaving
  };
}

function mapDispatchToProps(dispatch) {
  return {
    projectActions: bindActionCreators(ProjectActions, dispatch),
    gtmActions: bindActionCreators(GtmActions, dispatch),
    wizardActions: bindActionCreators(WizardActions, dispatch),
    routerActions: bindActionCreators(routerActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateUploadPropertyComp);



// WEBPACK FOOTER //
// ./src/wizard/SelectAnalyticsPropertyComp.js